import { defineComponent as y, computed as l, createElementBlock as r, openBlock as o, normalizeClass as v, renderSlot as z, createCommentVNode as s, createBlock as u, toDisplayString as g, unref as m, resolveDynamicComponent as w, toRaw as k } from "vue";
import { sizeNameToSize as C } from "@ds/components/Icon";
import { RevIllustration as S } from "@ds/components/Illustration";
import { tw as a } from "../../utils/tailwind.js";
const j = ["aria-label"], A = { key: 0 }, L = /* @__PURE__ */ y({
  name: "RevAvatar",
  __name: "Avatar",
  props: {
    size: {},
    label: {},
    thumbnail: { type: [String, Object, Function] }
  },
  setup(d) {
    const t = d, b = l(() => !t.thumbnail), c = l(() => typeof t.thumbnail == "string"), h = l(
      () => typeof t.thumbnail == "object" || typeof t.thumbnail == "function"
    ), f = l(() => t.label.charAt(0)), n = l(
      () => ({
        small: 20,
        medium: 40,
        large: 80
      })[t.size]
    ), p = l(() => {
      const e = a`bg-static-default-mid text-static-default-hi rounded-full flex items-center justify-center uppercase leading-none`, i = {
        small: a`body-2-bold size-20`,
        medium: a`font-weight-body-1-bold font-body-1-bold style-body-1-bold size-40 text-[1.25rem]`,
        large: a`font-weight-body-1-bold font-body-1-bold style-body-1-bold size-80 text-[2.75rem]`
      };
      return [e, i[t.size]];
    });
    return (e, i) => (o(), r("div", {
      "aria-label": e.label,
      class: v(p.value)
    }, [
      z(e.$slots, "default", {}, () => [
        b.value ? (o(), r("span", A, g(f.value), 1)) : s("", !0),
        c.value ? (o(), u(m(S), {
          key: 1,
          alt: e.label,
          class: "rounded-full",
          height: n.value,
          src: e.thumbnail,
          title: e.label,
          width: n.value
        }, null, 8, ["alt", "height", "src", "title", "width"])) : s("", !0),
        h.value ? (o(), u(w(k(e.thumbnail)), {
          key: 2,
          size: m(C)[e.size]
        }, null, 8, ["size"])) : s("", !0)
      ])
    ], 10, j));
  }
});
export {
  L as default
};
